import React from "react";
import { Tabs, Tab, Box } from "@mui/material";

const JobTabRoute = ({ tabLabels, activeTab, onTabChange }) => {
  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        textColor="primary"
        indicatorColor="primary"
      >
        {tabLabels.map((label, index) => (
          <Tab
            key={index}
            name={label}
            label={label}
            sx={{
              color: activeTab === label ? "black" : "gray",
              "&.Mui-selected": {
                color: "black",
              },
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default JobTabRoute;
